/**
 * Pure helpers for the pointer-based drag-and-drop.
 * Kept free of DOM access so they can be unit tested.
 */

/** Pixels the pointer must travel before a press becomes a drag. */
export const DRAG_THRESHOLD = 6;

/**
 * Has the pointer moved far enough to count as a drag rather than a tap?
 * @param {{x: number, y: number}} origin
 * @param {{x: number, y: number}} current
 * @param {number} [threshold]
 * @returns {boolean}
 */
export function exceedsDragThreshold(origin, current, threshold = DRAG_THRESHOLD) {
  const dx = current.x - origin.x;
  const dy = current.y - origin.y;
  return Math.hypot(dx, dy) >= threshold;
}

/**
 * Position for the floating drag ghost, clamped to the viewport so it can
 * never be dragged out of sight.
 * @param {{x: number, y: number}} pointer
 * @param {{x: number, y: number}} grabOffset pointer offset inside the card
 * @param {{width: number, height: number}} size card size
 * @param {{width: number, height: number}} viewport
 * @returns {{left: number, top: number}}
 */
export function clampGhostPosition(pointer, grabOffset, size, viewport) {
  const rawLeft = pointer.x - grabOffset.x;
  const rawTop = pointer.y - grabOffset.y;
  const maxLeft = Math.max(0, viewport.width - size.width);
  const maxTop = Math.max(0, viewport.height - size.height);
  return {
    left: Math.min(Math.max(rawLeft, 0), maxLeft),
    top: Math.min(Math.max(rawTop, 0), maxTop),
  };
}
